import React, { PureComponent } from "react";
import { store } from "app/store";

class Card extends PureComponent {
  render() {
    const colors = store.getState().settings.colors;
    const { style, children } = this.props;

    return (
      <div
        className={"deal-card"}
        style={{
          backgroundColor: colors.card_color,
          ...style
        }}
      >
        {children}
      </div>
    );
  }
}

export { Card };
